(function () {
    'use strict';
    var m = angular.module('app');
    m.service('rolesManager', ["$rootScope", "routeHelper", function ($rootScope, routeHelper) {
        var rolesManager = {
            isActionAllowed: function (allowedRolesList) {
                return allowedRolesList.includes($rootScope.userRole);
            },
            checkPermissionForRouter: function (allowedRoles) {
                if (allowedRoles && _(allowedRoles).isArray() && allowedRoles.length && !rolesManager.isActionAllowed(allowedRoles)) {
                    console.log('You are not allowed to view this page!');
                    routeHelper.redirectTo('dashboard');
                    return false;
                }
                return true;
            }
        };
        return rolesManager;
    }]);
}());